import React from 'react'

import { IPaper } from 'interfaces'

type IPaperVariantProps = {
  parentPaperData: IPaper | undefined
  flaggedQuestionList: string[] | undefined
}

const paperVariant = ({ parentPaperData, flaggedQuestionList }: IPaperVariantProps) => {
  const flaggedQuestions = parentPaperData?.flagged_questions
  const subSectionQuestions = parentPaperData?.subSectionQuestions
  const rejectedQuestions = parentPaperData?.rejectedQuestions
  const questionAnswer = parentPaperData?.questionAnswerKeys

  let newSubSectionQuestions: any[] = []
  let newQuestionAnswer: any[] = []
  subSectionQuestions?.map((eachSubsection: any) => {
    const qList = eachSubsection?.questionIds?.filter((qId: string) => !flaggedQuestionList?.includes(qId))
    newSubSectionQuestions.push({ id: eachSubsection.id, questionIds: qList })
  })
  questionAnswer?.filter((eachQuestion: any) => {
    if (!flaggedQuestionList?.includes(eachQuestion?.id)) {
      newQuestionAnswer.push(eachQuestion)
    }
  })
  return {
    ...parentPaperData,
    flagged_questions: [],
    rejectedQuestions: [],
    questionAnswerKeys: newQuestionAnswer,
    subSectionQuestions: newSubSectionQuestions,
  }
}

export default paperVariant
